import { Component } from '@angular/core';

@Component({
  selector: 'app-finance-icon',
  imports: [],
  templateUrl: './finance-icon.html',
  styleUrl: './finance-icon.css'
})
export class FinanceIcon {

}
